import { Drawer, Layout } from 'antd';
import styled from 'styled-components';

export const StyledHeader = styled(Layout.Header)`
  background-color: var(--neutral-14);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  height: 56px;
  color: var(--neutral-1);
  position: sticky;
  z-index: 8;
  top: 0;

  .mobile-menu-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
  }

  .mobile-header-right {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .account-selector {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-basis: 25%;

    img {
      filter: brightness(0) invert(1);
    }
  }

  .menu-wrapper {
    flex-basis: 50%;
    .ant-menu-horizontal {
      flex: 1;
      justify-content: center;
      line-height: 55px;
      text-transform: uppercase;

      .ant-menu-item span,
      .ant-menu-submenu-title span {
        font-size: 12px;
      }
      .ant-menu-item.ant-menu-item-selected {
        font-weight: 600;
      }

      /* Extend the active border indicator to be wider than the text */
      .ant-menu-item.ant-menu-item-selected::after,
      .ant-menu-item:hover::after {
        left: 4px !important;
        right: 4px !important;
      }

      /* Submenu title styles */
      .ant-menu-submenu-title {
        font-size: 12px;
      }
    }
  }

  .mobile-menu-button {
    display: none;
  }

  .user-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-basis: 25%;
    justify-content: flex-end;

    .user-info {
      display: flex;
      flex-direction: column;

      span {
        line-height: 15px;
        max-width: 135px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .user-role {
        font-size: 10px;
        font-weight: 300;
      }
    }

    .user-separator {
      width: 1px;
      height: 32px;
      background-color: var(--neutral-1);
      margin: 0 0 0 6px;
    }

    .user-dropdown {
      display: flex;
      align-items: center;
      gap: 12px;
      cursor: pointer;
      padding: 4px 8px 4px 0;
      border-radius: 0px;
    }
  }
`;

export const StyledMobileHeader = styled(Drawer)`
  background-color: var(--neutral-14) !important;

  .ant-drawer-header {
    background-color: var(--neutral-14) !important;
    border-bottom: none;
    padding: 23px 24px;

    .anticon {
      font-size: 24px;
      color: var(--neutral-1);
    }
  }

  .ant-drawer-body {
    padding-top: 0;
  }

  .ant-menu-item {
    padding-left: 0;
    line-height: 32px;

    span {
      font-size: 24px;
    }
  }

  .ant-menu-item.ant-menu-item-selected {
    background-color: transparent;
  }

  .ant-menu-item-disabled {
    color: var(--neutral-1) !important;
    opacity: 1 !important;
    cursor: default !important;
  }

  .account-selector-mobile {
    width: 160px;
    height: 40px;
    margin: 20px 0;

    .ant-select-selector {
      height: 42px;
    }

    .ant-select-selection-item {
      font-size: 24px;
    }

    .ant-select-arrow {
      margin-top: 0;
    }
  }

  .indented-menu-item {
    padding-left: 32px;
  }
`;
